import { assetThumbnailUrl } from '@/utils/assetUrls';
import { FlowGraph } from '../FlowGraph';
import type { ResolvedAssets } from '@/types/api/assets';
import type { NodeId } from 'web';

export class TrimView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  private getInputMedia() {
    const input = this.graph.evaluateInput(this.nodeId, 'file');
    return input?.type === 'video' || input?.type === 'audio' ? input : undefined;
  }

  /**
   * Single poster-frame thumbnail for the filmstrip backdrop. Only a raw source file has one — a
   * computed input (the live output of upstream graphics processing) has no URL to read frames
   * from, so the filmstrip falls back to a flat backdrop.
   */
  getInputThumbnailUrl(resolved: ResolvedAssets): string | undefined {
    const video = this.getInputVideoFile();
    return video ? assetThumbnailUrl(video, resolved, { type: 'video' }) : undefined;
  }

  /**
   * The connected source as a raw file, for callers that need to read its bytes (the filmstrip
   * seeks it frame by frame). `undefined` for a computed input, which has no seekable URL.
   */
  getInputVideoFile() {
    const input = this.getInputMedia();
    const video = input?.type === 'video' ? input.value : undefined;
    return video?.type === 'file' ? video : undefined;
  }

  setTrim(trimStart: number, trimEnd: number, ongoing: boolean = false) {
    this.graph.wasmEdit((wasm) => wasm.setTrim(this.nodeId, Math.max(0, trimStart), Math.max(0, trimEnd)), ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }
}
